import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Glyph from 'component/utils/Glyph'

const COLUMNS = ['dsFunc', 'cdType', 'dsTitle', 'view', 'edit', 'remove']

export default class Table extends PureComponent {
  renderHeader = (column, i) => {
    const { translate } = this.props

    let className = 'align-left'

    if (i > 2) {
      className = 'align-center'
    }

    return (
      <th key={column} ref={`column-ref-${column}`}>
        <div
          className={`${className} cell small-column`}
          style={{ minWidth: 'auto' }}
        >
          <div className='header'>
            {translate(`label.help.config.${column}`)}
          </div>
        </div>
      </th>
    )
  }

  renderRow = (row, i) => {
    const { handleDelete, handleUpdate, translate } = this.props

    return (
      <tr key={row.idHelpConfig}>
        {this.renderColumn('dsFunc', row.dsMenu, i, 'align-left')}
        {this.renderColumn(
          'cdType',
          row.typeConfig ? translate('option.video') : translate('option.text'),
          i,
          'align-left'
        )}
        {this.renderColumn('dsTitle', row.dsTitle, i, 'align-left')}
        {this.renderColumn(
          'view',
          <span className='table-icon' onClick={() => handleUpdate(row, true)}>
            <Glyph type='eye' color='primary' />
          </span>,
          i
        )}
        {this.renderColumn(
          'edit',
          <span className='table-icon' onClick={() => handleUpdate(row)}>
            <Glyph type='pencil' color='primary' />
          </span>,
          i
        )}
        {this.renderColumn(
          'remove',
          <span className='table-icon' onClick={() => handleDelete(row)}>
            <Glyph type='trash-can' color='danger' />
          </span>,
          i
        )}
      </tr>
    )
  }

  renderColumn = (key, data, i, className = 'align-center') => (
    <td
      key={key}
      ref={`column-ref-${key}-${i}`}
      className={`${className} cell-small`}
    >
      {data}
    </td>
  )

  render() {
    const { records, visible } = this.props

    return (
      <table
        className='table-adjustment bordered padding-top'
        style={{ fontSize: '0.9rem', width: visible ? '75vw' : '95vw' }}
      >
        <thead>
          <tr>{COLUMNS.map(this.renderHeader)}</tr>
        </thead>
        <tbody>{records.map(this.renderRow)}</tbody>
      </table>
    )
  }
}

Table.propTypes = {
  records: PropTypes.array,
  translate: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
}
